<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { Link, usePage } from "@inertiajs/vue3";

const locale = computed(() => usePage().props.locale);

// Layout
import PublicLayout from "@/Layouts/PublicLayout.vue";
import OverFirst from "@/Components/OverFirst.vue";
import OverSecond from "@/Components/OverSecond.vue";
import OverThird from "@/Components/OverThird.vue";
import OverFourth from "@/Components/OverFourth.vue";
import OverFifth from "@/Components/OverFifth.vue";
import OverSix from "@/Components/OverSix.vue";

const { t } = useI18n();

const props = defineProps({
  page: Object,
  jobOffers: Object,
  blogArticles: {
    type: Array,
    required: true
  }
});
</script>

<template>
  <PublicLayout title="Zorgblik">
    <OverFirst />
    <OverSecond />
    <OverThird />
    <OverFourth />
    <OverFifth />
    <OverSix />
  </PublicLayout>
</template>
